import {createActions} from 'redux-actions';

export default createActions({
    SET_MOVING_GOODS: undefined,
});